import type { BasicFilters } from '../../components/FilterPanel';
import type { SearchFilters } from '../../types/rpc-contracts';

// Priority program IDs from prod.seed_sources
const PRIORITY_PROGRAM_IDS = [
  "d5408a4a-daf0-48dc-ae65-e35ec58d807d", // American Fiction Awards
  "21138714-4ad5-4c3e-bf4a-a5e9528dbcdd", // American Legacy Book Awards
  "ca71a158-3fe9-4c45-a8c0-1ac8fa725683", // American Writing Awards
  "ff3c6327-4d23-41b0-a0fa-65f02a11c055", // AXIOM Business Book Awards
  "8dcd9737-5e68-47fd-ba46-912580989a6c", // Beach Book Festival
  "c6b22558-1b44-45d9-9645-78be92a93974", // Best Book Awards
  "23f8016e-bfe6-4422-98ae-6a0a56326f32", // Best Indie Book Award
  "37904772-c753-464b-aed7-44488e91ed4c", // Book Excellence Awards
  "2faa8ad4-9a1a-4108-ba49-3caca2261cb7", // BookFest Book Awards
  "26f340b7-b949-4177-8c43-280e224a2d70", // BREW Book Excellence Award
  "f67fe321-7239-46b5-8a9e-c78d8244a147", // BREW Children's Book Excellence Award
  "c0caef0e-8085-4671-a256-f81a5d612128", // BREW Fiction Book Excellence Award
  "38e9d162-c70b-46b9-aa66-304533154d2f", // BREW Nonfiction Book Excellence Award
  "af5fa54a-3269-496e-9cb5-1d6b9c9167ad", // California Book Awards
  "a869708e-be6d-427c-a05e-2eb4fb42d781", // Chanticleer Chatelaine Awards
  "d588e313-386c-41a7-ae5e-9262825039ff", // Chanticleer Chaucer Awards
  "99c34677-c311-4e75-a6cf-1201e83039d2", // Chanticleer Clue Awards
  "82a31919-acdd-40e8-8c72-f4c74d2023fa", // Chanticleer Fiction and Nonfiction Collections
  "2494b2df-df42-4f49-a2c6-b5a37f445a3f", // Chanticleer Goethe Awards
  "f03f500b-bd0f-4f06-b621-baab7f178e3e", // Chanticleer Harvey Chute Book Awards
  "769ceb9c-b649-447a-b4b9-fd657c8157d1", // Chanticleer Hemingway Awards
  "6bac1c80-1de8-40f7-ae01-dc165ce7c2b4", // Chanticleer Instruction & Insight Awards
  "55bd6041-8c80-4b23-86c5-d05a4ddf100d", // Chanticleer Laramie Awards
  "26cfb2c1-3167-4eb9-b635-aa1d43d9fc28", // Chanticleer Mark Twain Humor & Satire
  "59f39c1b-aeff-40d5-8c54-196164f7c80d", // Chanticleer Mystery & Mayhem Awards
  "2a50ac51-fdce-49bc-aada-5857e7d90204", // Chanticleer Somerset Book Awards
  "1349014b-b67c-477a-a330-7c250190de5b", // Children's Book International
  "4b9848db-29ff-4113-9f3c-0ce590710ffa", // Christian Indie Awards
  "f3edf45f-c258-464a-8871-2573d69481bb", // CIPA EVVY Awards
  "74c08cce-afd9-4931-a3f5-ad31adcc0afe", // Coffee Pot Book Club Book Awards
  "63f87093-28d1-419a-868b-14335a3cf9d3", // Dan Poynter's Global Ebook Awards
  "d4f4caa9-05ce-4e1a-b3a8-588fb2e947bd", // Feathered Quill Book Awards
  "aba11644-855c-4019-9d74-861734e4e7c5", // Global Book Awards
  "bee9340a-ff3f-4000-ac0d-65c24d0c4d1c", // Hawthorne Prize
  "5255acb4-c8d3-4fe7-a6ba-bc86fdc67452", // IBPA Book Award
  "f994f793-51a3-466b-a65f-320cd8b2dfff", // Independent Author Network
  "ca1a07b8-2244-478f-9223-6fd0bbe5438d", // Independent Press Award
  "c77ee174-0af4-4680-b930-e9fe73081659", // International Book Awards
  "5d3f273d-e23e-4aa3-bdcf-fd7033729b01", // International Firebird Book Awards
  "522cbcda-cf61-49de-afab-32c5b6d2fbe2", // IPPY Independent Publisher Book Awards
  "aa6f7844-349f-4941-b38d-d3b697179ac4", // Living Now Book Awards
  "f0cbade2-28de-4ec2-b1b4-7a909cae82f2", // Los Angeles Book Festival
  "3bf94a83-0cc3-4efb-9714-2656cf75b83c", // Maincrest Media Book Award Program
  "050d4e04-064e-4b48-bb7e-b3bb3ecdc01c", // Moonbeam Children's Book Awards
  "08db659a-2e17-4f44-9e1d-7c039a69b2f8", // National Indie Excellence Book Awards
  "4fb8db89-9578-4cc3-a255-3b15bdd6cf97", // New York City (NYC) Big Book Awards
  "2788a802-1710-486f-9638-cb12a39799ef", // Next Generation Indie Book Awards
  "6e663175-d434-4b0c-a5fe-839115170e0a", // Nonfiction Book Awards
  "9650215b-5882-4e1b-a594-e2a333e53fe3", // PEN/Faulkner Award for Fiction
  "bc5f37cd-dc22-441c-b6a5-b84a0a3c0910", // Pulitzer Prizes for Books
  "e44cbabd-8194-4418-83a5-0e4101b73eec", // Purple Dragonfly Book Awards
  "5e2389af-f495-4abc-865f-ade05590b97d", // Randolph Caldecott Medal
  "b5fe39ea-ce07-4518-b191-e5e073900245", // Royal Dragonfly Book Awards
  "eee26004-aaa5-4d2d-a3a3-c3f2e9aec8ff", // Sports Book of the Year
  "2f380a65-6e5b-48bc-accb-b7b40a5a6254", // The Christy Fiction Award
  "f2070512-858b-4349-8db3-74d6764059e0", // Writer's Digest Self-Published Book Awards
  "066aa370-c8e9-4070-8c52-a8f0b8289f8e"  // Writer's Digest Self-Published E-Book Awards
];

interface BuildFiltersParams {
  filters: BasicFilters;
  searchTerm: string;
  page: number;
  pageSize: number;
  categoryIds?: string[];
  readerSegment?: string | null;
  tier1?: string | null;
  tier2?: string | null;
}

const SORTABLE_FIELDS: Array<SearchFilters['sort_by']> = ['name', 'categories'];

const ynToBool = (value?: 'yes' | 'no' | 'all'): boolean | undefined => {
  if (value === 'yes') return true;
  if (value === 'no') return false;
  return undefined;
};

export function buildProgramSearchFilters({
  filters,
  searchTerm,
  page,
  pageSize,
  categoryIds,
  readerSegment,
  tier1,
  tier2
}: BuildFiltersParams): SearchFilters {
  const base: SearchFilters = {
    limit: pageSize,
    offset: page * pageSize,
    text_search: searchTerm ? searchTerm.trim() : undefined,
  };

  if (filters.sort_by && SORTABLE_FIELDS.includes(filters.sort_by)) {
    base.sort_by = filters.sort_by;
  }

  if (filters.sort_direction) {
    base.sort_direction = filters.sort_direction.toUpperCase() as SearchFilters['sort_direction'];
  }

  if (Array.isArray(filters.vetting_statuses) && filters.vetting_statuses.length > 0) {
    base.vetting_status = [...filters.vetting_statuses];
  }

  if (filters.foundation_year_range) {
    base.foundation_year_range = filters.foundation_year_range;
  }

  const isbnRequired = ynToBool(filters.isbn_required);
  if (isbnRequired !== undefined) {
    base.isbn_required = isbnRequired;
  }

  const indieAllowed = ynToBool(filters.independent_publishers_allowed);
  if (indieAllowed !== undefined) {
    base.independent_publishers_allowed = indieAllowed;
  }

  const multiplePrizes = ynToBool(filters.multiple_prizes_offered);
  if (multiplePrizes !== undefined) {
    base.multiple_prizes_offered = multiplePrizes;
  }

  if (filters.entry_fees && filters.entry_fees !== 'all') {
    base.entry_fee_required = filters.entry_fees === 'paid';
  }

  // Add priority filter (check both new and old field names for compatibility)
  if (filters.priority_only || (filters as any).seed_sources_only) {
    base.program_ids = PRIORITY_PROGRAM_IDS;
  }

  if (categoryIds && categoryIds.length > 0) {
    base.category_ids = categoryIds;
  }

  if (readerSegment) {
    base.reader_segment = readerSegment;
  }

  if (tier1) {
    base.category_tier1 = tier1;
  }

  if (tier2) {
    base.category_tier2 = tier2;
  }

  return base;
}

export function buildPrintFilters(searchFilters: SearchFilters): SearchFilters {
  const rest: SearchFilters = { ...searchFilters };
  delete rest.limit;
  delete rest.offset;
  return rest;
}
